<template lang="html">
  <div ref="vue2"></div>
</template>

<script>
// import { Chrome as ColorPicker } from 'vue-color'
const Util = window.Util;
const Vue = window.Vue;

export default {
  props: ['value'],
  emits: ['input'],
  data() {
    return {
      vue2Instance: null
    };
  },
  watch: {
    'value': function (newValue) {
      if (this.vue2Instance) {
        this.vue2Instance.brushColor = Util.jsonClone(newValue);
      }
    }
  },
  mounted() {
    const self = this;
    this.$refs.vue2.innerHTML = `<div>
      <chrome :value="brushColor" style="width: auto;" @input="changeBrushColor($event.rgba)"></chrome>
    </div>`;
    this.vue2Instance = new Vue({
      el: this.$refs.vue2.children[0],
      components: {
        'chrome': window.VueColor.Chrome
      },
      data() {
        return {
          brushColor: Util.jsonClone(self.value)
        };
      },
      methods: {
        changeBrushColor(rgba) {
          self.$emit('input', {
            rgba: Util.jsonClone(rgba)
          });
        }
      }
    });
  },
  beforeUnmount: function () {
    this.vue2Instance.$destroy();
  }
}
</script>

<style lang="css">
.vc-chrome, .vc-chrome-body {
  background: none !important;
  box-shadow: none !important;
  font-family: inherit !important;
}
.vc-chrome-fields .vc-input__input {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1) !important;
  color: inherit !important;
}
.vc-chrome-toggle-icon svg path {
  fill: rgba(255, 255, 255, 0.87) !important;
}
.vc-chrome-toggle-icon-highlight {
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>
